module.exports = __webpack_public_path__ + "media/images/color_admin_v3/login-bg/bg-1-4ba62277a46bfeb599f1ba0c97a10355.jpg";